export const environment = {
  production: false,
  // apiUrl: 'http://23.95.235.35/api/',
  apiUrl: "https://localhost:7075/api/",
  webSocketUrl: "https://webhook.site/PusherCommandReceiver",
  pusherChannelsKey: "9aef012304197ba34163",
  pusherChannelsCluster: "eu",
  pusherChannelsEventName: "general",
};
